import { call, delay, put, takeLatest } from "redux-saga/effects";
import { toast } from "react-toastify";

import { startLoader, stopLoader } from "../../../../utils/commonFunctions";
import { VasTypeActionTypes, VasTypeActions } from "../../../actionTypes/master/vasTypeActionTypes";
import { setPostApiStatus, setPutApiStatus } from "../../../actions/apiStatusActions";
import {
  createVasTypeApi,
  editVasTypeDataByIdApi,
  getVasTypeDataByIdApi,
  getVasTypeListApi,
} from "../../requests/master/vasTypeRequests";
import {
  getVasTypeList,
  setVasTypeDataById,
  setVasTypeList,
  setVasTypeListPageCount,
} from "../../../actions/master/vasTypeActions";


function* createVasTypeHandler(action: VasTypeActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(createVasTypeApi, action.payload);

    if (data.status) {
      toast.success(data?.message, {
        position: "top-right",
      });
      yield put(setPostApiStatus(true));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
    yield put(setPostApiStatus(false));
  } finally {
    yield stopLoader("transparent");
  }
}

function* getVasTypeListHandler(action: VasTypeActionTypes) {
  yield delay(500);
  try {
    yield startLoader("transparent");

    const { data } = yield call(getVasTypeListApi, action.payload);

    if (data.status) {
      yield put(setVasTypeList(data?.data?.rows ?? []));
      yield put(setVasTypeListPageCount(data?.data?.count ?? 0));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}

function* getVasTypeDataByIdHandler(action: VasTypeActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(getVasTypeDataByIdApi, action.payload);
    if (data.status) {
      yield put(setVasTypeDataById(data?.data));
    } else {
      toast.error(data?.message, {
        position: "top-right",
      });
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}

function* editVasTypeDataByIdHandler(action: VasTypeActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(editVasTypeDataByIdApi, action.payload);
    if (data.status) {
      toast.success(data.message, {
        position: "top-right",
      });
      yield put(setPutApiStatus(true));
      yield put(getVasTypeList({ page: 0, pageLimit: 10 }));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
    yield put(setPutApiStatus(false));
  } finally {
    yield stopLoader("transparent");
  }
}

export default function* vasTypeSaga() {
  yield takeLatest(VasTypeActions.CREATE_VAS_TYPE, createVasTypeHandler);
  yield takeLatest(VasTypeActions.GET_VAS_TYPE_LIST, getVasTypeListHandler);
  yield takeLatest(VasTypeActions.GET_VAS_TYPE_DATA_BY_ID, getVasTypeDataByIdHandler);
  yield takeLatest(VasTypeActions.EDIT_VAS_TYPE_DATA_BY_ID, editVasTypeDataByIdHandler);
}
